import { render } from "./criar_campos.vue?vue&type=template&id=589bccc0"
import script from "./criar_campos.vue?vue&type=script&lang=js"
export * from "./criar_campos.vue?vue&type=script&lang=js"

import "./criar_campos.vue?vue&type=style&index=0&id=589bccc0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__